import React from 'react';
import { Grid, Paper } from '@mui/material';
import styles from './GSDAppBarItems.module.css';
import FluxAppCard from '../../components/FluxAppCard/FluxAppCard';

const GsdAppBarItems = (props) => (
  <div className={styles.GsdAppBarItems}>
   <Paper className={styles.paperStyle}>
					<Grid 
						container 
						spacing={1}
						padding='10px'
						justifyContent="flex-start"
						sx={{
							'& .MuiGrid-item': {
								minWidth: 'fit-content'
							}
						}}
					>
						{props.applications.map((oneitem, idx) => {
							return (
								<React.Fragment key={`${idx}`}>
									<Grid 
										item
										xs={12}
										sm={6}
										md={4}
										lg={3}
										xl={3}
										sx={{
											display: 'flex',
											justifyContent: 'flex-start',
											padding: '10px !important'
										}}
									>
										<FluxAppCard {...oneitem}></FluxAppCard>
									</Grid>
								</React.Fragment>
							);
						})}
					</Grid>
				</Paper>
  </div>
);


export default GsdAppBarItems;
